import { gql } from 'apollo-angular';
export const get_project_photo = gql`
  query getProjectPhoto($projectId: ID!) {
    project(id: $projectId) {
      projectPhoto {
        filename
        filetype
        image
      }
    }
  }
`;
export var get_project_details = gql`
  query getProjectDetails($projectid: ID!) {
    project(id: $projectid) {
      id
      name
      ein
      ic_code
      sharepoint_folder
      description
      notes
      is_repeat
      teams_url
      is_synced_link
      ownedEntity {
        id
        name
        ownershipInterests {
          id
          ownedEntity {
            id
            name
          }
          ownedEntityOwner {
            id
            name
          }
          ownerType {
            id
            name
          }
        }
      }
      properties {
        id
        entity {
          id
          entityAddresses {
            address {
              id
              address1
              address2
              latitude
              longitude
              is_verified
              acs_year
              is_dda
              is_qct
              minority_pop_percent
              zipCode {
                zipcode
                city
                state {
                  abbreviation
                }
                county {
                  name
                  metroStatAreaCounties {
                    metroStatArea {
                      name
                    }
                  }
                }
              }
            }
          }
        }
      }
      projectType {
        name
      }
      projectDriveFolder {
        id
        path
        drive_path {
          path
        }
      }
      projectPhoto {
        filename
        filetype
        image
      }
      projectDetail {
        id
        risk_rating
        syndications_notes
        has_set_asides
        loi_expiration_date
        effective_closing_date
        leverage
        closing_feasibility_notes
        rate_locked_flag
        fully_disposed
      }
      projectSubstatuses {
        id
        project_status_id
        subsequence_id
        substatus_id
      }
      projectSubstatusDates {
        id
        project_status_id
        subsequence_id
        substatus_id
        date
        utc_time
        timezone
        target
      }

      dispositions {
        id
        organization {
          id
          name
        }
        purchaser
        disposition_type_id
        disposition_bov_id
        related_party
        recapture_bond
        recapture_exposure
        is_final
        disposition_legal_status_id
        disposition_yield_request_status_id
        crea_rofr
        monitoring_compliance
        board_consent_na
        investor_consent_na
        dispositionType {
          id
          name
        }
        dispositionStatuses {
          active
          statusSequence {
            id
            name
          }
          status {
            id
            name
          }
        }

        dispositionDates {
          date
          dateType {
            name
          }
          dateClass {
            name
          }
        }
        dispositionPipelineDates {
          date
          initial_target
          target
          pipelineMilestone {
            milestone {
              name
            }
          }
        }
      }
      developer: participants(
        hasRole: { column: NAME, operator: EQ, value: "Developer" }
      ) {
        organization {
          id
          name
          originatorRelationship {
            id
            is_originated
            person {
              id
              name
            }
          }
          sponsor {
            id
            name
            is_repeat
            originatorRelationship {
              id
              is_originated
              person {
                id
                name
              }
            }
          }
        }
        person {
          id
          name
        }
      }
      projectStatuses {
        id
        is_primary
        active
        status {
          id
          name
        }
        statusSequence {
          id
          name
          status_sequence_details {
            index
            status {
              id
              name
            }
            milestoneStatus {
              id
              pipeline_milestone_id
              status_sequence_detail_id
            }
          }
        }
      }
      pipelineProjects {
        id
        active
        pipelineProjectDates {
          id
          date
          initial_target
          target
          pipelineMilestone {
            milestone {
              name
            }
            milestoneStatus {
              id
              pipeline_milestone_id
              status_sequence_detail_id
            }
          }
        }
        pipeline {
          name
        }
      }
      projectDates {
        id
        date
        dateClass {
          id
          name
        }
        dateType {
          id
          name
          model
          active
        }
      }
      projectMilestoneDates {
        id
        date
        active
        dateType {
          id
          name
        }
        pipelineMilestone {
          id
        }
      }
      projectCredits {
        id
        amount
        price
        equity_amount
        certificated
        crea_syndicated
        taxCreditType {
          id
          name
          level
        }
        taxCreditDesignation {
          id
          name
        }
        projectCreditStatus {
          id
          name
        }
        projectCreditOutlets {
          id
          ownership
          estimated_gross_equity
          gross_equity
          purchase_amount
          admitted_date
          exit_date
          warehoused
          warehouse_funding_deadline_date
          warehouse_funding_deadline_time
          warehouse_funding_deadline_timezone
          fundProjectState {
            id
            name
            index
          }
          fund {
            id
            name
            close_date
            fundType {
              name
            }
            fundStatuses {
              statusSequence {
                name
              }
              status {
                name
              }
            }
            participants {
              role {
                name
                roleType {
                  name
                }
              }
              person {
                id
                name
              }
              organization {
                id
                name
                sponsor {
                  id
                  name
                  is_repeat
                }
              }
            }
          }
          certificatedOutlet {
            id
            organization {
              id
              name
            }
            participants {
              role {
                name
                roleType {
                  name
                }
              }
              person {
                id
                name
              }
              organization {
                id
                name
                sponsor {
                  id
                  name
                  is_repeat
                }
              }
            }
          }
        }
      }
      properties {
        buildings
        total_units
        total_lihtc_units
        total_market_rate_units
        total_rental_assistance_units
        total_common_units
        total_studio_units
        total_family_units
        total_senior_units
      }
      projectAttributes {
        id
        attribute {
          name
          nickname
          abbreviation
          description
          is_default
          attributeType {
            id
            name
            is_dynamic
            active
          }
        }
      }
      ltmodels(
        active: true
        hasModelType: { column: NAME, operator: EQ, value: "LTForecast" }
      ) {
        active_model
        created
        milestone {
          name
        }
        scenario {
          name
        }
        modelType {
          name
        }
        kpiset {
          id
          kpiset_detail {
            hard_debt
            lower_tier_yield
          }
          pricePerCredits {
            equity_amount
            benefitType {
              id
              name
            }
          }
          financingTerms {
            id
            is_final
            financingTermType {
              name
            }
            loan {
              id
              amount
              available_to_investor
              loanType {
                id
                name
              }
              lender {
                id
                name
                organization {
                  id
                  name
                }
              }
            }
          }
        }
      }
      participants {
        id
        role {
          id
          name
          roleType {
            name
          }
        }
        person {
          id
          name
          entity {
            entity_types {
              type {
                name
                tagType {
                  name
                }
              }
            }
          }
        }
        sponsor {
          id
          name
          nickname
          is_repeat
          originatorRelationship {
            person {
              id
              name
            }
            id
          }
        }
        organization {
          id
          name
          sponsor {
            id
            name
            is_repeat
            originatorRelationship{
              person {
                name
                id
              }
            }
          }
          entity {
            entity_types {
              type {
                name
                tagType {
                  name
                }
              }
            }
          }
        }
      }
      projectSetAsides {
        id
        total
        is_hard
        setAsideType {
          id
          name
        }
      }
      applications {
        id
        amount_requested
        request_date
        awarded
        project_id
        taxCreditType {
          level
          name
        }
        taxCreditDesignation {
          name
        }
        fundingRound {
          id
          year
          number
          name
          due_date
          award_date
          organization {
            id
            name
          }
          state {
            name
          }
        }
        organization {
          id
          name
        }
        person {
          id
          name
        }
      }
      creawebAssetManagementField {
        id
        special_needs_set_aside_description
        other_reports
        other_green_features
        green_features_flag
        green_building_certifications
      }
      creawebConstructionField {
        id
        probable_max_loss
        recognized_enviromental_conditions
        construction_review_findings
        environment_review_findings
      }
      financingTerms {
        id
        is_final
        financingTermType {
          name
        }
        loan {
          id
          amount
          available_to_investor
          loanType {
            id
            name
          }
          lender {
            id
            name
            organization {
              id
              name
            }
          }
        }
      }
      projectPricingDetail {
        id
        #        syndications_questions, syndications_pricing_reasoning,
        non_cra_execution
      }
    }
    owned_entity_type_by_name(name: "Middle-Tier Entity") {
      id
      name
    }
    owner_type_by_name(name: "Middle-Tier") {
      id
      name
    }
    drive_path_by_type(type: "sharepoint") {
      id
      path
    }
    y_drive: drive_path_by_type(type: "projects") {
      id
      path
    }
    crea_link: drive_path_by_type(type: "crealink_deal") {
      id
      path
    }
    date_type(name: "Forecast Approval") {
      id
    }
    placement_guidance_expiration_date: date_type(
      name: "Placement Guidance Expiration"
    ) {
      id
    }
    placement_guidance_issued_date: date_type(
      name: "Placement Guidance Issued"
    ) {
      id
    }
    response_to_developer_needed: date_type(
      name: "Response to Developer Needed"
    ) {
      id
    }
    fund_project_states {
      name
      id
    }
    roles {
      id
      name
      active
      roleType {
        id
        name
      }
    }
    attribute_types(active: true) {
      id
      name
      attributes {
        id
        name
      }
      permissions {
        _create
        _read
        _edit
        _delete
      }
    }
    taxCreditTypes(active: true) {
      id
      name
      level
    }
    taxCreditDesignations(active: true) {
      id
      name
    }
    projectCreditStatuses(active: true) {
      id
      name
    }
    loanTypes(active: true) {
      id
      name
    }
    financingTermType(name: "Loan") {
      id
      name
    }
    date_types(active: true) {
      id
      name
      model
      permissions {
        _create
        _read
        _edit
        _delete
      }
    }
    subsequences {
      id
      name
      substatuses {
        id
        name
        statusSubstatuses {
          status_sequence_id
          status_id
          index
        }
      }
      permissions {
        _create
        _edit
        _delete
      }
    }
    setAsideTypes(active: true) {
      id
      name
    }
    actualDateClass: date_class_by_name(name: "actual") {
      id
      name
    }
    targetDateClass: date_class_by_name(name: "target") {
      id
      name
    }
    closingSequence: status_sequences_by_name(name: "Closing") {
      id
      name
    }
    managingSequence: status_sequences_by_name(name: "Managing") {
      id
      name
    }
    syndicationsSequence: status_sequences_by_name(name: "Syndications") {
      id
      name
    }
    syndicationsStatuses: statusesBySequence(sequence_name: "Syndications") {
      name
      id
      statusSequenceDetails {
        status_sequence_id
        statusSequence {
          id
          name
        }
      }
    }
    deadSequence: status_sequences_by_name(name: "Dead") {
      id
      name
    }
    deadStatus: status_by_name(name: "Dead") {
      id
    }
    me {
      addressPermissions: permissionsForResource(resourceType: ADDRESS) {
        _edit
      }
      applicationPermissions: permissionsForResource(
        resourceType: APPLICATION
      ) {
        _edit
      }
      creawebAssetManagementFieldPermissions: permissionsForResource(
        resourceType: CREAWEBASSETMANAGEMENTFIELD
      ) {
        _edit
      }
      creawebConstructionFieldPermissions: permissionsForResource(
        resourceType: CREAWEBCONSTRUCTIONFIELD
      ) {
        _edit
      }
      loansPermissions: permissionsForResource(resourceType: LOAN) {
        _edit
      }
      projectPermissions: permissionsForResource(resourceType: PROJECT) {
        _edit
        _delete
      }
      projectDetailPermissions: permissionsForResource(
        resourceType: PROJECTDETAIL
      ) {
        _edit
      }
      projectPhotoPermissions: permissionsForResource(
        resourceType: PROJECTPHOTO
      ) {
        _edit
      }
      projectDriveFolderPermissions: permissionsForResource(
        resourceType: PROJECTDRIVEFOLDER
      ) {
        _edit
      }
      projectCreditOutletPermissions: permissionsForResource(
        resourceType: PROJECTCREDITOUTLET
      ) {
        _edit
      }
      #      I KNOW, it's hardcoded. I don't know how to look up the permissions for a specific status sequence without
      #      having to do a separate API call just to get the sequence permissions. Any suggestions are welcome - Sarah
      closingStatusSequencePermissions: permissionsForResource(
        resourceType: STATUSSEQUENCE
        resourceId: "1"
      ) {
        _edit
      }
      deadStatusSequencePermissions: permissionsForResource(
        resourceType: STATUSSEQUENCE
        resourceId: "2"
      ) {
        _edit
      }
      syndicationsStatusSequencePermissions: permissionsForResource(
        resourceType: STATUSSEQUENCE
        resourceId: "4"
      ) {
        _edit
      }
      managingStatusSequencePermissions: permissionsForResource(
        resourceType: STATUSSEQUENCE
        resourceId: "5"
      ) {
        _edit
      }

      dateTypePermissions: permissionsForResource(resourceType: DATETYPE) {
        _edit
      }
      proposalDeadlineDateTypePermissions: permissionsForResource(
        resourceType: DATETYPE
        resourceId: "d53e1f59-84cf-11eb-a944-00505601010e"
      ) {
        _edit
      }
      fullClosedDateTypePermissions: permissionsForResource(
        resourceType: DATETYPE
        resourceId: "d6b1300f-6a17-11e9-8d8f-00505601010e"
      ) {
        _edit
      }
      capitalReapprovedDateTypePermissions: permissionsForResource(
        resourceType: DATETYPE
        resourceId: "d6b131e5-6a17-11e9-8d8f-00505601010e"
      ) {
        _edit
      }
      forecastApprovalDateTypePermissions: permissionsForResource(
        resourceType: DATETYPE
        resourceId: "4e529b0e-5374-11ec-bf63-0242ac130002"
      ) {
        _edit
      }
      projectPricingDetailPermissions: permissionsForResource(
        resourceType: PROJECTPRICINGDETAIL
      ) {
        _edit
      }
      groups(pivot: { active: true }) {
        name
      }

      groupsFlattened {
        name
      }
    }
  }
`;

export var get_credits_by_project = gql`
    query getProjectDetailCredits($id: ID!){
      project(id: $id){
        projectStatuses {
          id
          is_primary
          active
          status {
            id
            name
          }
          statusSequence {
            id
            name
            status_sequence_details {
              index
              status {
                id
                name
              }
              milestoneStatus {
                id
                pipeline_milestone_id
                status_sequence_detail_id
              }
            }
          }
        }
        projectCredits {
          id
          amount
          price
          equity_amount
          certificated
          crea_syndicated
          taxCreditType {
            id
            name
            level
          }
          taxCreditDesignation {
            id
            name
          }
          projectCreditStatus {
            id
            name
          }
          projectCreditOutlets {
            id
            ownership
            estimated_gross_equity
            gross_equity
            purchase_amount
            admitted_date
            exit_date
            warehoused
            warehouse_funding_deadline_date
            warehouse_funding_deadline_time
            warehouse_funding_deadline_timezone
            fundProjectState {
              id
              name
              index
            }
            fund {
              id
              name
              close_date
              fundType {
                name
              }
              fundStatuses {
                statusSequence {
                  name
                }
                status {
                  name
                }
              }
              participants {
                role {
                  name
                  roleType {
                    name
                  }
                }
                person {
                  id
                  name
                }
                organization {
                  id
                  name
                  sponsor {
                    id
                    name
                    is_repeat
                  }
                }
              }
            }
            certificatedOutlet {
              id
              organization {
                id
                name
              }
              participants {
                role {
                  name
                  roleType {
                    name
                  }
                }
                person {
                  id
                  name
                }
                organization {
                  id
                  name
                  sponsor {
                    id
                    name
                    is_repeat
                  }
                }
              }
            }
          }
        }
      }
    }
`
export var update_project_profile_details = gql`
  mutation updateDealProfileDetails(
    $id: ID!
    $projectInput: ProjectProfileInput!
    $entityID: ID
    $entityName: String!
  ) {
    updateProjectProfile(id: $id, input: $projectInput) {
      name
      ein
    }
    updateProjectEntity(id: $entityID, name: $entityName, project_id: $id) {
      id
      name
    }
  }
`;

export var update_project_profile = gql`
  mutation updateDealProfile(
    $id: ID!
    $projectInput: ProjectProfileInput!
    $icCode: String
    $entityID: ID
    $entityName: String!
  ) {
    updateProjectProfile(id: $id, input: $projectInput) {
      name
      ein
    }
    updateProjectICCode(id: $id, ic_code: $icCode) {
      ic_code
    }
    updateProjectEntity(id: $entityID, name: $entityName, project_id: $id) {
      id
      name
    }
  }
`;

export var update_project_and_update_folder = gql`
  mutation updateProjectAndUpdateFolder(
    $id: ID!
    $projectInput: ProjectProfileInput!
    $icCode: String
    $entityID: ID
    $entityName: String!
    $pathID: ID!
    $path: String
  ) {
    updateProjectProfile(id: $id, input: $projectInput) {
      name
      ein
    }
    updateProjectICCode(id: $id, ic_code: $icCode) {
      ic_code
    }
    updateProjectEntity(id: $entityID, name: $entityName, project_id: $id) {
      id
      name
    }
    updateDealFolder(id: $pathID, path: $path) {
      id
      path
    }
  }
`;

export var update_project_and_update_folder_no_ic = gql`
  mutation updateProjectAndUpdateFolderNoIC(
    $id: ID!
    $projectInput: ProjectProfileInput!
    $entityID: ID
    $entityName: String!
    $pathID: ID!
    $path: String
  ) {
    updateProjectProfile(id: $id, input: $projectInput) {
      name
      ein
    }
    updateProjectEntity(id: $entityID, name: $entityName, project_id: $id) {
      id
      name
    }
    updateDealFolder(id: $pathID, path: $path) {
      id
      path
    }
  }
`;

export var update_project_and_create_new_folder = gql`
  mutation updateProjectAndCreateNewFolder(
    $id: ID!
    $projectInput: ProjectProfileInput!
    $icCode: String
    $entityID: ID
    $entityName: String!
    $driveID: ID!
    $path: String
  ) {
    updateProjectProfile(id: $id, input: $projectInput) {
      name
      ein
    }
    updateProjectICCode(id: $id, ic_code: $icCode) {
      ic_code
    }
    updateProjectEntity(id: $entityID, name: $entityName, project_id: $id) {
      id
      name
    }
    createDealFolder(path: $path, project_id: $id, drive_path_id: $driveID) {
      id
      path
    }
  }
`;

export var update_project_and_create_new_folder_no_ic = gql`
  mutation updateProjectAndCreateNewFolder(
    $id: ID!
    $projectInput: ProjectProfileInput!
    $entityID: ID
    $entityName: String!
    $driveID: ID!
    $path: String
  ) {
    updateProjectProfile(id: $id, input: $projectInput) {
      name
      ein
    }
    updateProjectEntity(id: $entityID, name: $entityName, project_id: $id) {
      id
      name
    }
    createDealFolder(path: $path, project_id: $id, drive_path_id: $driveID) {
      id
      path
    }
  }
`;

export var create_new_folder = gql`
  mutation createNewFolder($id: ID!, $driveID: ID!, $path: String) {
    createDealFolder(path: $path, project_id: $id, drive_path_id: $driveID) {
      id
      path
    }
  }
`;

export var update_folder = gql`
  mutation updateFolder($pathID: ID!, $path: String) {
    updateDealFolder(id: $pathID, path: $path) {
      id
      path
    }
  }
`;

export var update_ic_code = gql`
  mutation updateICCode($id: ID!, $icCode: String) {
    updateProjectICCode(id: $id, ic_code: $icCode) {
      ic_code
    }
  }
`;

export var update_ic_code_new_folder = gql`
  mutation updateICCodeNewFolder(
    $id: ID!
    $icCode: String
    $driveID: ID!
    $path: String
  ) {
    updateProjectICCode(id: $id, ic_code: $icCode) {
      ic_code
    }
    createDealFolder(path: $path, project_id: $id, drive_path_id: $driveID) {
      id
      path
    }
  }
`;

export var update_ic_code_update_folder = gql`
  mutation updateICCodeUpdateFolder(
    $id: ID!
    $icCode: String
    $path: String
    $pathID: ID!
  ) {
    updateProjectICCode(id: $id, ic_code: $icCode) {
      ic_code
    }
    updateDealFolder(id: $pathID, path: $path) {
      id
      path
    }
  }
`;

export var create_owned_entity = gql`
  mutation createOwnedEntity($name: String!) {
    createOwnedEntity(name: $name) {
      id
      name
    }
  }
`;

export var create_entity_attribute_ownership_interest = gql`
  mutation createOwnershipInterest(
    $owned_entity_id: ID!
    $owner_type_id: ID!
    $operating_entity_id: ID!
    $owned_entity_type_id: ID!
  ) {
    createOwnershipInterest(
      owned_entity_id: $operating_entity_id
      owner_type_id: $owner_type_id
      owned_entity_owner_id: $owned_entity_id
    ) {
      id
      owned_entity_owner_id
    }
    createOwnedEntityAttribute(
      owned_entity_id: $owned_entity_id
      owned_entity_type_id: $owned_entity_type_id
    ) {
      id
      owned_entity_id
    }
  }
`;
export var delete_middle_tier_entity = gql`
  mutation removeMiddleTierEntity($owned_entity_id: ID!) {
    deleteOwnedEntity(id: $owned_entity_id) {
      id
    }
  }
`;
export var delete_forecast_approval_date = gql`
  mutation deleteForecastApprovalDate($id: ID!) {
    deleteForecastApprovalDate(id: $id) {
      id
    }
  }
`;

export var delete_deal = gql`
  mutation deleteDeal($id: ID!) {
    deleteDeal(id: $id) {
      id
    }
  }
`;
